module.exports = __webpack_public_path__ + "static/media/Ellipse 1.d9820b93.png";